<template>
  <div class="communityHome">
    <communityHeader :router_url='router_url'></communityHeader>

    <!-- 关注 -->
    <div class="content of_h">
      <div class="contentWidth of_h ">
        <div class="contLeft min_h_768 fc_l mt_20">
          <div class="hd of_h">
            <h3 class="fc_l">关注</h3>
          </div>
          <div class="bd anmition_show">
            <follow_list></follow_list>
          </div>
        </div>
        <div class="contRight fc_r mt_20">
          <!-- <Intelligent></Intelligent> -->
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import communityHeader from '@/components/community/common/communityHeader.vue'
import loading from '@/components/loading/loading.vue'
import follow_list from '@/components/community/user_follow/follow_list.vue'
import { Info } from '@/utils/api/login.js'


export default {
  name: 'communityHome',
  data () {
    return {
      loading: true,
      hotCircles: [],
      joinStatte: false,

      defaultImg: 'this.src="' + require('@/assets/image/common/loading.gif') + '"',//未加载
      error_login: require('@/assets/image/common/loading.gif'),

    }
  },
  components: {
    communityHeader,
    follow_list,
    loading
  },

  created () {
    this.is_login();//是否登陆
    this.router_url = this.$route.fullPath;//当前地址url

  },
  methods: {
    // 是否登录
    is_login () {
      Info().then((res) => {
        let data = res.data;
        this.isLogin = data.isLogin
        if (this.isLogin == true) {
          this.isLogin_user = data.user
        }
        else {
          sessionStorage.setItem('router_url', this.router_url)//地址
          this.$router.push(
            {
              path: '/login/?state=' + 1,
            }
          )
        }
      })
    },

  }
}
</script>
<style lang="scss" scoped="scoped">
div.content {
  background: #f5f5f5;
  div.contentWidth {
    margin: 0 auto;
    padding-bottom: 20px;
  }
  div.contLeft {
    width: 928px;
    div.hd {
      padding: 0 15px;
      border-bottom: 1px #ddd solid;
      background: #fff;
      border-radius: 5px 5px 0 0;
      h3 {
        display: inline-block;
        height: 60px;
        line-height: 60px;
        padding-left: 30px;
        font-size: 18px;
        font-weight: bold;
        color: #d4021b;
        background: url("../../assets/image/community/hdico.png") 0 center
          no-repeat;
      }
      ul {
        li {
          display: inline-block;
          height: 58px;
          line-height: 58px;
          padding: 0 10px;
          font-size: 16px;
          cursor: pointer;
          border-bottom: 2px #fff solid;
          margin-left: 30px;
          color: #888;
          &.on {
            border-color: #d4021b;
            color: #333;
          }
        }
      }
    }
    div.bd {
    }
  }
  div.contRight {
    width: 355px;
    button.publish {
      display: block;
      width: 100%;
      height: 70px;
      line-height: 70px;
      text-align: center;
      border: 0;
      transition: all 1s;
      font-size: 18px;
      color: #fff;
      background-image: linear-gradient(to right, #d7172e, #ff4001);
      &:hover {
        background-image: linear-gradient(to right, #c00, #f00);
      }
    }
  }
}

.boxbg_err {
  width: 306px;
  height: 128px;
  position: absolute;
  top: 0;
  z-index: 20;
  border-radius: 4px 4px 0 0;
}
</style>



// WEBPACK FOOTER //
// src/views/community/user_follow.vue